import script from "./MembresiasList.vue?vue&type=script&setup=true&lang=js"
export * from "./MembresiasList.vue?vue&type=script&setup=true&lang=js"

import "./MembresiasList.vue?vue&type=style&index=0&id=6b1b0590&scoped=true&lang=css"
import "./MembresiasList.vue?vue&type=style&index=1&id=6b1b0590&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1b0590"]])

export default __exports__